// Refactor 02/2026 — extrahiert aus AppointmentsPage.js (Drag-Cursor-Follower).
import React from 'react';
import { createPortal } from 'react-dom';

export const DragCursorFollower = ({
  draggedAppointment,
  draggedParticipant,
  dragCursorPos,
}) => {
  if (!(draggedAppointment || draggedParticipant) || !dragCursorPos) return null;

  // 10/2026 Fix: via Portal an <body> rendern. Vorher war der Follower ein
  // bedingtes Kind des `space-y-6`-Containers → sobald er beim Drag-Start
  // erschien, bekam das nächste Geschwister-Element margin-top:1.5rem und das
  // ganze Grid sprang 24px (=12min) nach unten → Slot unter dem Cursor
  // verschob sich → „muss hin- und herschieben".
  return createPortal(
    <div
      className="fixed pointer-events-none"
      style={{
        left: `${dragCursorPos.x + 10}px`,
        top: `${dragCursorPos.y + 10}px`,
        zIndex: 10001,
        transform: 'translate(0, 0)',
      }}
      data-testid="drag-cursor-follower"
    >
      <div className="bg-teal-600 text-white text-xs font-bold px-3 py-2 rounded-lg shadow-2xl border-2 border-teal-400">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 bg-white rounded-full animate-pulse" />
          <span>
            {draggedParticipant
              ? `${draggedParticipant.customerName} verschieben...`
              : 'Verschieben...'}
          </span>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DragCursorFollower;
